import React from "react";
import ConfirmDialog, {
    ExtendedDialogProps,
} from "../components/Shared/ConfirmDialog";
import {Layout} from "../types/utils";

interface ConfirmationContextValues {
    show: boolean
    title: string
    subtitle: string
    description: string
    dialog?: ExtendedDialogProps
    callback?: any
    setConfirmation: any
    resetConfirmation: any
    loading: boolean
    typingValue: string
    renderChildren: any
}

const defaultValues: ConfirmationContextValues = {
    show: false,
    title: "",
    subtitle: "",
    description: "",
    dialog: undefined,
    callback: undefined,
    loading: false,
    setConfirmation: () => {
    },
    resetConfirmation: () => {
    },
    typingValue: "",
    renderChildren: () => {
    },
};

const ConfirmationContext =
    React.createContext<ConfirmationContextValues>(defaultValues);

export const ConfirmationContextProvider: React.FC<Layout> = ({children}) => {
    const [confirmation, setConfirmation] =
        React.useState<ConfirmationContextValues>(defaultValues);

    function resetConfirmation() {
        return setConfirmation((confirmation) => ({
            ...confirmation,
            show: false,
        }));
    }

    const value = {
        ...confirmation,
        setConfirmation,
        resetConfirmation,
    };

    const dialogContext = {
        ...confirmation.dialog,
        open: true,
        close: () => resetConfirmation(),
        callback: confirmation.callback,
        typingValue: confirmation.typingValue,
        renderChildren: confirmation.renderChildren,
    };

    return (
        <ConfirmationContext.Provider value={value}>
            {children}
            {confirmation?.show && <ConfirmDialog {...dialogContext} />}
        </ConfirmationContext.Provider>
    );
};

// eslint-disable-next-line react-refresh/only-export-components
export const useConfirmationContext = () => {
    return React.useContext(ConfirmationContext);
};

export default ConfirmationContextProvider;
